import { useEffect, useMemo, useRef } from "react";

export function useWorkspaceScope<Args extends unknown[]>(key: string, notify: (...args: Args) => void) {
  const mounted = useRef(true);
  const current = useRef({ key, notify });
  if (current.current.key !== key) current.current = { key, notify };
  current.current.notify = notify;
  const context = current.current;
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  return useMemo(() => ({
    isCurrent: () => mounted.current && current.current === context,
    notify: (...args: Args) => {
      if (mounted.current && current.current === context) context.notify(...args);
    },
  }), [context]);
}
